import styled from "styled-components";

interface ReportModalProps{
    isOpen:boolean,
    value:string,
    onChange:(value:string) => void,
    onConfimClickHandler:() => void
    onCancelClickHandler:() => void
}

const ReportModal = ({isOpen, value, onChange, onConfimClickHandler, onCancelClickHandler}:ReportModalProps) => {
    if(!isOpen){
        return null;
    }
    return(
        <Container>
            <Modal>
                <TitleWrap>
                    <Title>이름 변경</Title>
                    <TitleSub>폴더 또는 과제 이름을 입력해 주세요</TitleSub>
                </TitleWrap>
                <Input value={value} onChange={(e) => onChange(e.target.value)}/>
                <ButtonWrap>
                    <Button onClick={onConfimClickHandler}>확인</Button>
                    <ButtonCancel onClick={onCancelClickHandler}>취소</ButtonCancel>
                </ButtonWrap>
            </Modal>
        </Container>
    )
}

const Container = styled.div`
    position: fixed;
    top:0;
    min-height: 100vh;
    min-width: 100vw;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
`

const Modal = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
    padding: 28px;
    width: 420px;
    min-width: 300px;
    background-color: white;
    border-radius: 16px;
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);
`

const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Title = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #0F172A;
`;

const TitleSub = styled.div`
  text-align: center;
  font-size: 14px;
  color: #64748B;
`;

const Input = styled.input`
    width: 100%;
    padding: 12px 14px;
    background-color: #F8FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    font-size: 14px;
    color: #0F172A;

    &:focus {
        outline: none;
        border-color: #DF0000;
        background: #FFFFFF;
        box-shadow: 0 0 0 3px rgba(223, 0, 0, 0.12);
    }
`

const ButtonWrap = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: center;
`

const Button = styled.button`
    height: 50px;
    padding: 0 40px;
    background-color: #df0000;
    color: white;
    border: none;
    border-radius: 52px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: 0.3s;
`;

const ButtonCancel = styled.button`
    height: 50px;
    padding: 0 40px;
    background-color: white;
    color: #df0000;
    border: 1px solid #df0000;
    border-radius: 52px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: 0.3s;
`

export default ReportModal;